import { useTranslation } from 'react-i18next';
import { Box, Paper, Typography } from '@mui/material';
import { usePlatformAuth } from '../contexts/PlatformAuthContext';
import { useMetrics } from '../hooks/api/useMetrics';
import { PlatformMetricsView } from '../components/metrics/PlatformMetricsView';

export function DashboardPage() {
  const { t } = useTranslation();
  const { admin } = usePlatformAuth();
  const { data: metrics, isLoading, error } = useMetrics();

  return (
    <Box>
      <Paper sx={{ p: { xs: 2, sm: 3 }, mb: { xs: 2, sm: 3 } }}>
        <Typography variant="h5" gutterBottom>
          {t('dashboard.title')}
        </Typography>
        <Typography variant="body1">{t('dashboard.welcome', { email: admin?.email ?? '' })}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {t('dashboard.role', { role: admin?.role ?? '' })}
        </Typography>
      </Paper>

      <PlatformMetricsView metrics={metrics} isLoading={isLoading} error={error} scope="platform" />
    </Box>
  );
}
